module.exports = __webpack_public_path__ + "img/home-slider.a73f911a.jpg";